import { RouteConfig } from 'vue-router';
import SnbProfile from './snb-profile.vue';
import SnbOrgProfile from './snb-org-profile.vue';

export const SnbProfileRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'profile',
  component: SnbProfile,
};

export const SnbOrgProfileRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'org-profile',
  component: SnbOrgProfile,
};

export function getDefaultParams() {
  return {};
}

// export default SnbProfileRoute;
